<template>
  <div class="completed">
    <div class="page-header">
      <!-- <v-btn icon depressed dark class="btn-back" @click="$emit('clickBack')">
        <v-icon dark>mdi-arrow-left</v-icon>
      </v-btn> -->
      <h3 class="page-title">회원 가입 하기</h3>

    </div>
    <div class="header-top">
      <img src="@/assets/images/common/complete_header_bg.png" />

    </div>
    <div class="container">
      <div class="page-inner">
        <h1 class="step-title">
          <img src="@/assets/images/common/img_success.png" alt="" />
          팜파트너
        </h1>
        <h4 class="step-sub-title">회원가입을 축하드립니다.</h4>

        <img class="img-gift" src="@/assets/images/common/img_gift.png" alt="" />
        <p>
          <b>농협 농촌사랑 e 상품권 (1만원권)</b><br />
          가입하신 해당 월말에 모바일 쿠폰1만원이 별도로 발송
        </p>
        <div class="bottom-btn">
          <v-btn color="primary" x-large outlined block rounded class="mb-3" @click="$emit('goToHome')">홈으로</v-btn>
          <!-- <v-btn
          color="primary"
          x-large
          depressed
          block
          rounded
          @click="$emit('goToHome')"
          >추가정보</v-btn
        > -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {},
};
</script>

<style lang="scss">
.completed {
  padding: 0 0 140px;

  .header-top {
    width: 100%;
    margin-top: -74px;
    overflow: hidden;
    border-radius: 0 0 20px 20px;
    height: 300px;

    img {
      width: 100%;
      // height: 100%;
    }
  }

  .step-title {
    font-size: 36px;
    margin-bottom: 10px;

    img {
      width: 80px;
      vertical-align: bottom;
      margin: 0 0 0 -90px;
    }
  }

  .step-sub-title {
    font-size: 20px;
    color: #666666;
    margin-bottom: 20px;
  }

  .page-inner {
    text-align: center;
  }

  .img-gift {
    height: 100px;
  }

  p {
    color: #666666;

    b {
      color: #000000;
      font-size: 18px;
    }
  }
}
</style>